<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Familia
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Maestros</span>
      <span> /</span>
      <span>Familia</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
  <div class="card mb-2 wow">
    <!--Card content-->
    <div class="card-body justify-content-between">
      <div class="row filtros-header" style="border-bottom: 1px solid #dee2e6">
        <div></div>
        <button type="button" mdbBtn color="info" size="sm" mdbWavesEffect (click)="openModalFamilia()">
          Agregar
        </button>
      </div>
      <div class="row filtros-body">
        <div class="col" style="display:flex;">
          <!-- Material inline 1 -->
          <div class="form-check form-check-inline">
            <input type="radio" class="form-check-input" id="materialInline1" name="inlineMaterialRadiosExample"
              [(ngModel)]="busquedaEstado" [value]="1" mdbInput />
            <label class="form-check-label" for="materialInline1">Activos</label>
          </div>

          <!-- Material inline 2 -->
          <div class="form-check form-check-inline">
            <input type="radio" class="form-check-input" id="materialInline2" name="inlineMaterialRadiosExample"
              [(ngModel)]="busquedaEstado" [value]="2" mdbInput />
            <label class="form-check-label" for="materialInline2">Inactivos</label>
          </div>

          <div class="form-check form-check-inline">
            <input type="radio" class="form-check-input" id="materialInline3" name="inlineMaterialRadiosExample"
              [(ngModel)]="busquedaEstado" [value]="3" mdbInput />
            <label class="form-check-label" for="materialInline3">Todos</label>
          </div>
          <div class="col" style="max-width: 300px">
            <div class="md-form">
              <div class="md-form">
                <input value="" type="text" id="desc" class="form-control" [(ngModel)]="filtroNombre" placeholder="Nombre" required #desc />
                <label for="desc">Nombre</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6">
      <div></div>
      <button mdbBtn (click)="buscar()" color="secondary" size="sm" mdbWavesEffect type="submit">
        <mdb-icon fas icon="search"></mdb-icon>
        Buscar
      </button>
    </div>
  </div>
<!-- Cabecera de botones -->
<div class="card mb-2 wow">
  <!--Card content-->
  <div class="card-body">
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col" style="width: 300px;">Nombre</th>
            <th scope="col" style="width: 200px;">Rubro</th>
            <th scope="col" style="width: 200px;">Estado</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let familia of listaFamilias">
            <td>{{familia.nombre}}</td>
            <td>{{familia.rubro_nombre}}</td>
            <td>
              <mdb-badge pill="true" success="true" *ngIf="familia.activo">Activo</mdb-badge>
              <mdb-badge pill="true" warning="true" *ngIf="!familia.activo">Inactivo</mdb-badge>
            </td>
            <td><button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
                mdbTooltip="Editar" placement="right" (click)="editar(familia)">
                <mdb-icon fas icon="pen"></mdb-icon>
              </button>
              <button class="btn-actions-sm" color="primary" mdbBtn type="button" mdbWavesEffect *ngIf="!familia.activo"
                mdbTooltip="Activar" placement="right" (click)="activar(familia)">
                <mdb-icon fas icon="ban"></mdb-icon>
              </button>
              <span class="btn-actions-sm" *ngIf="!familia.activo">&nbsp;</span>
              <button class="btn-actions-sm" color="success" mdbBtn type="button" mdbWavesEffect *ngIf="familia.activo"
                mdbTooltip="Desactivar" placement="right" (click)="desactivar(familia)">
                <mdb-icon fas icon="check"></mdb-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
        *ngIf="listaFamilias?.length > 0"></app-pagination>
    </div>
  </div>
</div>

<!-- MODAL Agregar e Editar Familia -->
<app-familia-modal-add-edit (onAddEdit)="onAddEdit($event)"></app-familia-modal-add-edit>